import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {LocaleService} from '../services/locale.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageInterceptor implements HttpInterceptor {
  private localeService = inject(LocaleService);

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const modifiedRequest = request.clone({
      setHeaders: {
        'Accept-Language': this.localeService.language(),
      },
    });

    return next.handle(modifiedRequest);
  }
}
